/**
 * @generated SignedSource<<931b8a8e2d118f3bc5a3772b6e630d17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_rules" | "RowWithSiblingCreate_rules">;
  readonly " $fragmentType": "Row_rules";
};
export type Row_rules$key = {
  readonly " $data"?: Row_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Row_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_rules"
    },
    {
      "kind": "FragmentSpread",
      "name": "RowWithSiblingCreate_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "7dff2c26d095d5e3683d5477fc25813c";

export default node;
